import { GameTagType } from "entities/tagTypes/types";
import { v4 as uuidv4 } from "uuid";
import { TagOption } from "widgets/ModuleTagsWidget/type";
import { create } from "zustand";

export type GameTagOption = {
  id: string;
  name: string;
};

export type GameTagBlock = {
  id: string;
  tagType: GameTagType | null;
  primaryTagId: string | null;
  selectedTags: GameTagOption[];
};

export type GameTagsDataStore = {
  gameTagTypeBlocks: GameTagBlock[];
  setGameTagTypeBlocks: (tagBlocks: GameTagBlock[]) => void;
  addGameTagTypeBlock: () => void;
  deleteGameTagTypeBlock: (blockId: string) => void;
  changeGameTagType: (blockId: string, tagType: GameTagType) => void;
  changeGameTagPrimaryTag: (blockId: string, primaryTagId: string) => void;
  changeGameTagTags: (blockId: string, newTags: TagOption[]) => void;
  clearGameTagsData: () => void;
};

export const useGameTagsData = create<GameTagsDataStore>((set) => ({
  gameTagTypeBlocks: [],
  setGameTagTypeBlocks: (gameTagTypeBlocks) => set({ gameTagTypeBlocks }),
  addGameTagTypeBlock: () => {
    const newBlock: GameTagBlock = {
      id: uuidv4(),
      tagType: null,
      primaryTagId: null,
      selectedTags: [],
    };

    return set((state) => ({
      gameTagTypeBlocks: [...state.gameTagTypeBlocks, newBlock],
    }));
  },
  deleteGameTagTypeBlock: (blockId: string) =>
    set((state) => ({
      gameTagTypeBlocks: state.gameTagTypeBlocks.filter((block) => {
        return block.id !== blockId;
      }),
    })),
  changeGameTagType: (blockId, tagType) =>
    set((state) => ({
      gameTagTypeBlocks: state.gameTagTypeBlocks.map((block) => {
        if (block.id === blockId) {
          return {
            ...block,
            tagType,
            primaryTagId: null,
            selectedTags: [],
          };
        }
        return block;
      }),
    })),
  changeGameTagPrimaryTag: (blockId, primaryTagId) =>
    set((state) => ({
      gameTagTypeBlocks: state.gameTagTypeBlocks.map((block) => {
        if (block.id === blockId) {
          return {
            ...block,
            primaryTagId,
          };
        }
        return block;
      }),
    })),
  changeGameTagTags: (blockId, newTags) =>
    set((state) => ({
      gameTagTypeBlocks: state.gameTagTypeBlocks.map((block) => {
        if (block.id === blockId) {
          return {
            ...block,
            selectedTags: newTags,
          };
        }
        return block;
      }),
    })),
  clearGameTagsData: () =>
    set({
      gameTagTypeBlocks: [],
    }),
}));
